module.exports = __webpack_public_path__ + "static/img/hot-Grade2.c22f9761.png";